import useDeepMemo from './useDeepMemo';

const useConsistentReference = <TValue>(value: TValue) => {
    return useDeepMemo(() => {
        return value;
    }, value);
};

export default useConsistentReference;
